export default __webpack_public_path__ + "static/media/ER7.4700b71d.png";